import { Component, OnInit } from '@angular/core';
import {Input} from '@angular/core';
import {_HttpClient} from '@delon/theme';
import {SystemContants} from '@core/constants';
import {LodopService} from '@delon/abc';
import {NzMessageService} from 'ng-zorro-antd';
import {Lodop} from '@delon/abc';
import {ElementRef} from '@angular/core';
import {ViewChild} from '@angular/core';
import {style} from '@angular/animations';

@Component({
  selector: 'app-bill-detail-viewer',
  templateUrl: './bill-detail-viewer.component.html',
  styles: []
})
export class BillDetailViewerComponent implements OnInit {

  @Input()
  details: any[] = [];

  @Input()
  record: any = {};

  printError: boolean = true;
  lodop: any = null;

  @ViewChild("billDom")
  billDom: ElementRef;

  constructor(private http: _HttpClient, public lodopSrv: LodopService, private msg: NzMessageService) {
    this.lodopSrv.cog = Object.assign({}, {url: 'http://localhost:8000/CLodopfuncs.js', license: null, licenseA: null});
    this.lodopSrv.lodop.subscribe(({ lodop, ok }) => {
      if (!ok) {
        this.printError = false;
        return;
      }
      this.printError = true;
      this.lodop = lodop as Lodop;
    });
  }

  ngOnInit() {
    if (this.record.id != null) {
      this.loadDetails();
    }
  }

  loadDetails() {
    this.http.get<any>("api/app/bill/detail/group/list/"+this.record.id).subscribe((resp) => {
      if (resp.status === SystemContants.STATUS_SUCCESS) {
        this.details = resp.data;
      }
    })
  }

  getTotal(details: any[]) {
    var total = 0;
    if (details == null) {
      this.details.forEach(type => {
        type.billDetails.forEach((detail) => {
          total += detail.amount;
        });
      })
    }else {
      details.forEach((detail) => {
        total += detail.amount;
      });
    }
    return total;
  }


  print(isPrivew = true) {
    if (!this.printError) {
      this.msg.error("请下载打印插件");
      return;
    }
    const LODOP = this.lodop!;
    LODOP.PRINT_INITA(10, 20, 810, 610, '账单打印');
    LODOP.SET_PRINT_PAGESIZE(0, 0, 0, '');
    var style = '<style>td, th{border-bottom:1px solid #dddddd;line-height:30px;vertical-align: middle;}th{background:#f2f2f2;}</style>'
    LODOP.ADD_PRINT_HTM(20, 10, '90%', '95%', style+this.billDom.nativeElement.innerHTML);

    if (isPrivew) LODOP.PREVIEW();
    else LODOP.PRINT();
  }

}
